import { prop } from 'ramda';

import { isUserAuthenticated } from 'app/features/user/selectors';
import { getUserAnonymousId } from 'app/analytics/helpers';

const fetchToken =
  () =>
  (_, getState, { api }) =>
    api
      .createToken({
        isUserAuthenticated: isUserAuthenticated(getState()),
        anonymousId: getUserAnonymousId(),
      })
      .then(prop('data'));

export { fetchToken };
